import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../colors";

export const useContactStyles = makeStyles({
    contactLink: {
        color: colors.text.primary,
        fontStyle: 'italic'
    }
});
